import HighchartsReact from "highcharts-react-official";
import React, { useState, FC, useEffect } from "react";
import * as Highcharts from "highcharts";
// import HighchartsReact from "highcharts-react-official";
import styled from "styled-components";
export interface ISeriesDataType {
  name?: string;
  y?: number;
}

interface IDonutProps {
  data: ISeriesDataType[];
  backgroundColor?: string;
  highcharts?: any;
  title?: string;
  width?: number;
  height?: number;
  fontSize?: number;
  fontStyle?: string;
}

const DonutChart: FC<IDonutProps> = ({
  data,
  backgroundColor,
  highcharts,
  title,
  width,
  height,
  fontSize,
  fontStyle,
}) => {
  const colors = ["#F7A35B", "#7CB5EC", "#90ED7D", "#434348", "#F15C80", "#E4D354"];
  const [chartOptions, setChartOptions] = useState({
    title: title !== undefined ? { useHTML: true, text: `<h4>${title}</h4>` } : "",
    chart: {
      type: "pie",
      height: height ?? 230,
      width: width ?? 430,
      backgroundColor: backgroundColor ?? `rgba(0, 0, 0, 0)`,
      fontStyle: fontStyle,
    },
    plotOptions: {
      pie: {
        dataLabels: {
          format: "{point.name}",
        },
        innerSize: "50%",
      },
      series: {
        dataLabels: {
          enabled: true,
          format: "{name}",
          style: {
            font: fontStyle,
          },
        },
      },
    },
    series: [
      {
        name: "Concepts",
        data: data?.map(({ name, y }, index) => {
          return { name, y, color: colors[index] };
        }),
      },
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 400,
          },
        },
      ],
    },
    credits: {
      enabled: false,
      DonutChart,
    },
    exporting: {
      enabled: false,
    },
  });

  useEffect(() => {
    if (data?.length > 0) {
      setChartOptions((state) => ({
        ...state,
        series: [
          {
            name: "Concepts",
            data: data?.map(({ name, y }, index) => {
              return { name, y, color: colors[index] };
            }),
          },
        ],
      }));
    }
  }, [data]);

  return (
    <StyledDiv className="donut-chart-container">
      <HighchartsReact
        highcharts={Highcharts}
        options={chartOptions}
        allowChartUpdate={true}
        containerProps={{ className: "highcharts-background" }}
      />
    </StyledDiv>
  );
};

export default React.memo(DonutChart);

const StyledDiv = styled.div`
  max-width: 100%;
  background: white;
  border-radius: 10px !important;
  ${(props) => (props.title !== undefined ? `box-shadow: 0px 0px 17px -2px rgb(0 0 0 / 8%);` : "")}
  .highcharts-background {
    border-radius: 10px !important;
    background-color: rgba(0, 0, 0, 0);
    max-width: 100%;
    .highcharts-container {
      max-width: 100%;
      svg {
        max-width: 100%;
      }
      .highcharts-title {
        top: 24px !important;
        left: 24px !important;
      }
    }
  }
  h4 {
    font-family: "Roboto Slab";
    font-weight: bold;
    font-size: 28px;
  }
`;
